/* ==========================================================================
   BSC Academy — nastri orizzontali · v1 · 25/08/2026

   Comportamento generico, dichiarato dal markup:

     [data-nastro-zona]     il contenitore che tiene insieme pista e pulsanti
       [data-nastro]        la pista scorrevole
         [data-nastro-passo="1"]   quante schede per clic (default 1)
       [data-nastro-prec] / [data-nastro-succ]   i due pulsanti

   Il passo si MISURA dalla scheda e dal gap veri. Con un numero scritto a
   mano basta cambiare una larghezza nel CSS e lo scorrimento sbaglia bersaglio.

   Le frecce sono un di piu: senza JS la pista scorre lo stesso — col dito,
   col trackpad, con la rotella — e i pulsanti restano disabilitati come
   nascono nel markup.
   ========================================================================== */
(function () {
  'use strict';

  function init(zona) {
    if (!zona || zona.dataset.bscNastroInit) { return; }

    var pista = zona.querySelector('[data-nastro]');
    var prec = zona.querySelector('[data-nastro-prec]');
    var succ = zona.querySelector('[data-nastro-succ]');
    if (!pista || !prec || !succ) { return; }

    zona.dataset.bscNastroInit = '1';

    var passo = parseInt(pista.dataset.nastroPasso, 10) || 1;

    function quanto() {
      var sc = pista.firstElementChild;
      if (!sc) { return pista.clientWidth; }
      var gap = parseFloat(getComputedStyle(pista).columnGap) || 0;
      return (sc.getBoundingClientRect().width + gap) * passo;
    }

    /* 2px di tolleranza: scrollLeft e frazionario e non arriva mai esatto */
    function stato() {
      var fine = pista.scrollWidth - pista.clientWidth - 2;
      prec.disabled = pista.scrollLeft <= 2;
      succ.disabled = pista.scrollLeft >= fine;
    }

    prec.addEventListener('click', function () { pista.scrollBy({ left: -quanto(), behavior: 'smooth' }); });
    succ.addEventListener('click', function () { pista.scrollBy({ left:  quanto(), behavior: 'smooth' }); });
    pista.addEventListener('scroll', stato, { passive: true });
    window.addEventListener('resize', stato);

    /* ⚠️ Lo stato va RICALCOLATO quando il contenuto si assesta, non solo
       all'avvio. Alla prima lettura la pista puo ancora essere larga quanto
       il suo contenitore — immagini non arrivate, font non applicati — e
       `scrollWidth == clientWidth` significa «non c'e niente da scorrere»:
       la freccia destra nasceva spenta e restava spenta, perche l'unico
       evento che la riaccendeva era uno scroll che nessuno poteva fare.
       Trovato dal test nel browser, non a occhio. (Rami, 25/08)

       Un ResizeObserver sulla PISTA non basta: la sua scatola non cambia
       quando cresce il contenuto dentro. Va osservata la prima scheda. */
    if (window.ResizeObserver) {
      var occhio = new ResizeObserver(stato);
      occhio.observe(pista);
      if (pista.firstElementChild) { occhio.observe(pista.firstElementChild); }
    }

    window.addEventListener('load', stato);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(stato); }

    /* le immagini delle schede cambiano l'ingombro quando arrivano */
    var img = pista.querySelectorAll('img');
    for (var i = 0; i < img.length; i++) {
      if (!img[i].complete) { img[i].addEventListener('load', stato, { once: true }); }
    }

    stato();
  }

  function tutte(scope) {
    var n = (scope || document).querySelectorAll('[data-nastro-zona]');
    for (var i = 0; i < n.length; i++) { init(n[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { tutte(document); });
  } else { tutte(document); }

  document.addEventListener('shopify:section:load', function (e) { tutte(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var n = e.target.querySelectorAll('[data-nastro-zona]');
    for (var i = 0; i < n.length; i++) { delete n[i].dataset.bscNastroInit; }
  });
})();
